import postcodeClassLookupJSON from './postcodeClassLookup.json';
var postcodeClassLookup = postcodeClassLookupJSON;
export var getPostCodeClass = function (postcode) {
    return postcodeClassLookup[postcode];
};
